import React from "react";
import { connect } from "react-redux";
import {
  Col,
  Label,
  Row,
  TabContent,
} from "reactstrap";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { deepClone } from "../../../../../helpers/objectHelper";
import { formActions } from "../../../../../store/actions/cms/form/form.action";
import InvoiceFieldSettings from "./InvoiceFieldSettings/InvoiceFieldSettings";
import { ElementTabGroup } from "../../../../components/editor/tools/EditorTabGroup";
import ListExpansion from "../../../../../components/UI/ListExpansion/ListExpansion";
import JirangoSwitch from "../../../../../components/UI/Switch/JirangoSwitch";

class PaymentOptionSettings extends React.Component {
  state = { activeTab: new Array(2).fill("1") };
  toggle = (tabPane, tab) => {
    const newArray = this.state.activeTab.slice();
    newArray[tabPane] = tab;
    this.setState({
      activeTab: newArray
    });
  };

  handlePaymentMethodChange = (e, method) => {
    let newElement = deepClone(this.props.element);
    if (!newElement.data) {
      newElement.data = { paymentMethods: [] };
    }
    if (e.target.checked) {
      newElement.data.paymentMethods.push(method);
    }
    else if (newElement.data.paymentMethods.indexOf(method) > -1) {
      newElement.data.paymentMethods.splice(newElement.data.paymentMethods.indexOf(method), 1);
    }
    this.props.dispatch(formActions.updateFormElement(newElement));
  };
  renderPaymentAlternatives = () => {
    const { form, element } = this.props;
    if (!element.data) {
      element.data = { paymentMethods: [] };
    }
    return (<React.Fragment>
      {form.availableModules.find(am => am.name === "DIBS") ?
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="DibsPayment" />
            </Label>
          </Col>
          <Col
            className="list-setting-item-input"
            style={{ textAlign: "right" }}
          >
            <JirangoSwitch
              onChange={e => this.handlePaymentMethodChange(e, `dibs`)}
              isChecked={
                element.data.paymentMethods.includes("dibs") || false
              }
            />
          </Col>
        </Row>
        : null
      }
      {form.availableModules.find(am => am.name === "Invoice") ?
        <Row>
          <Col className="list-setting-item-title">
            <Label>
              <SystemLabel name="InvoicePayment" />
            </Label>
          </Col>
          <Col
            className="list-setting-item-input"
            style={{ textAlign: "right" }}
          >
            <JirangoSwitch
              onChange={e => this.handlePaymentMethodChange(e, `invoice`)}
              isChecked={
                element.data.paymentMethods.includes("invoice") || false
              }
            />
          </Col>
        </Row>
        : null
      }
    </React.Fragment>)
  };
  render() {
    const { activeTab } = this.state;
    return (
      <React.Fragment>
        <div>
          <ElementTabGroup activeTab={this.state.activeTab[0]} toggle={this.toggle} />
          <TabContent
            className="editor-tabcontent"
            style={{ paddingBottom: '65px' }}
            activeTab={
              this.state.activeTab[0]
            }>
            {this.state.activeTab[0] === "1" ?
              <ListExpansion
                footer={false}
                icon="fa fa-square"
                defaultExpanded={true}
                description="PaymentOption"
              >
                {this.renderPaymentAlternatives()}
              </ListExpansion>
              : null}
            {this.state.activeTab[0] === "2" ?
              <InvoiceFieldSettings />
              : null}
            {this.state.activeTab[0] === "3" ?
              null
              : null}
          </TabContent>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,
    template: state.template,
    cms: state.cms
  };
}

export default connect(mapStateToProps)(PaymentOptionSettings);
